import { InteractionEntity } from '../../../coaching-base/config';
import { createAction } from '../../../store.model';
import { InteractionFormValue } from '../../observation-interaction/interaction-form-value.model';

import { EvaluationDetails } from './evaluation-details.model';

export enum ActionType {
    COACHING__FOCUS_SUMMARY__RELOAD = 'COACHING__FOCUS_SUMMARY__RELOAD',
    COACHING__FOCUS_SUMMARY__RELOAD_RESULT = 'COACHING__FOCUS_SUMMARY__RELOAD_RESULT',
    COACHING__FOCUS_SUMMARY__RELOAD_CANCEL = 'COACHING__FOCUS_SUMMARY__RELOAD_CANCEL',
    COACHING__FOCUS_SUMMARY__RECALCULATE = 'COACHING__FOCUS_SUMMARY__RECALCULATE',
}

export interface Reload {
    performerId: number;
    behaviourId: number;
    subBehaviourId: number;
    observationId?: number;
    interactionEntity: InteractionEntity;
    published: boolean;
    interactions: InteractionFormValue[];
}

export const reload = createAction<ActionType, Reload>(
    ActionType.COACHING__FOCUS_SUMMARY__RELOAD,
);

export interface ReloadResult extends Reload {
    evaluationsDetails?: EvaluationDetails[];
}

export const reloadResult = createAction<ActionType, ReloadResult>(
    ActionType.COACHING__FOCUS_SUMMARY__RELOAD_RESULT,
);

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ReloadCancel {}

export const reloadCancel = createAction<ActionType, ReloadCancel>(
    ActionType.COACHING__FOCUS_SUMMARY__RELOAD_CANCEL,
);

/// ///////

export interface Recalculate {
    mode: 'observation' | 'commitment';
    interactionEntity: InteractionEntity;
    published: boolean;
    interactions: InteractionFormValue[];
}

export const recalculate = createAction<ActionType, Recalculate>(
    ActionType.COACHING__FOCUS_SUMMARY__RECALCULATE,
);
